import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "../../components/layout/PageHeader";
import NewBookDocumentModal from "./NewBookDocumentModal";
import { BookOpen, Upload, LayoutTemplate, Wand2, FolderOpen, Sparkles } from "lucide-react";

const CARDS = [
  { id: "start", label: "Start Book", icon: BookOpen, desc: "Fresh manuscript with InDesign-grade controls.", preset: "print" },
  { id: "upload", label: "Upload Manuscript", icon: Upload, desc: "DOCX, PDF, Google Doc — we set up the document for you.", preset: "upload" },
  { id: "templates", label: "Browse Templates", icon: LayoutTemplate, desc: "Workbook, KDP, ebook, comic — premium starters.", preset: "workbook" },
  { id: "ai", label: "Generate With AI", icon: Wand2, desc: "Outline, draft, design — AI runs the first pass.", preset: "ai-start" },
  { id: "open", label: "Open Existing Project", icon: FolderOpen, desc: "Continue where you left off.", preset: "recent" },
];

export default function EditorStudio() {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [preset, setPreset] = useState("print");

  const launch = (p) => {
    if (p === "recent") {
      nav("/book-lab/editor?preset=recent&title=The%20Operator%27s%20Playbook");
      return;
    }
    setPreset(p);
    setOpen(true);
  };

  return (
    <div data-testid="editor-studio-page" className="space-y-8">
      <PageHeader
        kicker="BookLab · Editor Studio"
        title="Open the Editor Studio"
        description="Beginner-friendly like Canva. Pro-grade like InDesign. Built for books, workbooks, KDP interiors, ebooks, and guides."
        actions={
          <button
            data-testid="editor-quick-open"
            onClick={() => launch("print")}
            className="inline-flex items-center gap-2 px-4 h-11 rounded-xl pl-btn-aqua text-sm"
          >
            <Sparkles className="h-4 w-4" /> Open Editor
          </button>
        }
      />

      <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {CARDS.map((c, i) => {
          const I = c.icon;
          return (
            <button
              key={c.id}
              data-testid={`studio-${c.id}`}
              onClick={() => launch(c.preset)}
              className="pl-fade-up text-left rounded-2xl p-6 border border-[var(--pl-border)] bg-[var(--pl-surface)]/60 backdrop-blur-md pl-lift pl-contour-card"
              style={{ animationDelay: `${i * 50}ms` }}
            >
              <div className="h-12 w-12 rounded-2xl bg-[var(--pl-aqua)]/10 border border-[var(--pl-aqua)]/30 grid place-items-center">
                <I className="h-6 w-6 text-[var(--pl-aqua)]" strokeWidth={1.6} />
              </div>
              <div className="font-display text-lg font-semibold text-[var(--pl-text)] mt-4">{c.label}</div>
              <p className="text-sm text-[var(--pl-text-muted)] mt-1.5">{c.desc}</p>
              <div className="mt-4 inline-flex items-center gap-1 text-xs text-[var(--pl-aqua)]">
                Open <span aria-hidden>→</span>
              </div>
            </button>
          );
        })}
      </section>

      <NewBookDocumentModal open={open} onOpenChange={setOpen} initialPreset={preset} />
    </div>
  );
}
